"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRequest = void 0;
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
async function makeRequest(network, chain, query, variables) {
    const url = getUrl(network, chain);
    const res = await (0, isomorphic_fetch_1.default)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            query,
            variables: variables || {}
        })
    });
    const jsonRes = await res.json();
    if (jsonRes.errors) {
        throw new Error(jsonRes.errors[0].message);
    }
    return jsonRes.data;
}
exports.makeRequest = makeRequest;
function getUrl(network, chain) {
    if (chain === 'gnosis') {
        chain = 'xdai';
    }
    if (chain === 'ethereum') {
        chain = 'mainnet';
    }
    if (network === 'goerli') {
        if (chain === 'mainnet') {
            chain = 'goerli';
        }
        if (chain === 'polygon') {
            chain = 'mumbai';
        }
        if (chain === 'optimism') {
            chain = 'optimism-goerli';
        }
        if (chain === 'arbitrum') {
            throw new Error(`chain "${chain}" is not supported on goerli subgraphs`);
        }
        if (chain === 'xdai') {
            throw new Error(`chain "${chain}" is not supported on goerli subgraphs`);
        }
        return `https://api.thegraph.com/subgraphs/name/hop-protocol/hop-${chain}`;
    }
    if (chain === 'mainnet') {
        // return 'https://gateway.thegraph.com/api/bd5bd4881b83e6c2c93d8dc80c9105ba/subgraphs/id/Cjv3tykF4wnd6m9TRmQV7weiLjizDnhyt6x2tTJB42Cy'
    }
    return `https://api.thegraph.com/subgraphs/name/hop-protocol/hop-${chain}`;
}
